import * as CONST from "./actionTypes";

export const emailTemp = (payload, callBack) => {
  return {
    type: CONST.EMAIL_TEMP_LIST,
    payload: { ...payload },
    callBack,
  };
};

export const emailTemp_Success = (payload) => ({
  type: CONST.EMAIL_TEMP_LIST_SUCCESS,
  payload,
});

export const emailTemp_Fail = (payload) => ({
  type: CONST.EMAIL_TEMP_LIST_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> EDIT CUSTOMER >>>>>>>>>>>>>>>*/
export const emailTempId = (payload, callBack) => {
  return {
    type: CONST.EMAIL_TEMP_ID,
    payload: payload,
    callBack,
  };
};

export const emailTempId_Success = (payload) => ({
  type: CONST.EMAIL_TEMP_ID_SUCCESS,
  payload,
});

export const emailTempId_Fail = (payload) => ({
  type: CONST.EMAIL_TEMP_ID_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> UPDATE USER >>>>>>>>>>>>>>>*/

export const updateEmailtemp = (payload, callBack) => {
  return {
    type: CONST.UPDATE_EMAIL_TEMP,
    payload: { ...payload },
    callBack,
  };
};

export const updateEmailtemp_Success = (payload) => ({
  type: CONST.UPDATE_EMAIL_TEMP_SUCCESS,
  payload,
});

export const updateEmailtemp_Fail = (payload) => ({
  type: CONST.UPDATE_EMAIL_TEMP_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> ADD USER >>>>>>>>>>>>>>>*/

export const addEmailTemp = (payload, callBack) => {
  return {
    type: CONST.ADD_EMAIL_TEMP,
    payload: { ...payload },
    callBack,
  };
};

export const addEmailTemp_Success = (payload) => ({
  type: CONST.ADD_EMAIL_TEMP_SUCCESS,
  payload,
});

export const addEmailTemp_Fail = (payload) => ({
  type: CONST.ADD_EMAIL_TEMP_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> DELETE USER >>>>>>>>>>>>>>>*/

export const deleteEmailTemp = (payload, callBack) => {
  return {
    type: CONST.DELETE_EMAIL_TEMP,
    payload: { ...payload },
    callBack,
  };
};

export const deleteEmailTemp_Success = (payload) => ({
  type: CONST.DELETE_EMAIL_TEMP_SUCCESS,
  payload,
});

export const deleteEmailTemp_Fail = (payload) => ({
  type: CONST.DELETE_EMAIL_TEMP_FAIL,
  payload,
});

// SMS ==================== //

export const smsTemp = (payload, callBack) => {
  return {
    type: CONST.SMS_TEMP_LIST,
    payload: { ...payload },
    callBack,
  };
};

export const smsTemp_Success = (payload) => ({
  type: CONST.SMS_TEMP_LIST_SUCCESS,
  payload,
});

export const smsTemp_Fail = (payload) => ({
  type: CONST.SMS_TEMP_LIST_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> EDIT CUSTOMER >>>>>>>>>>>>>>>*/
export const smsTempId = (payload, callBack) => {
  return {
    type: CONST.SMS_TEMP_ID,
    payload: payload,
    callBack,
  };
};

export const smsTempId_Success = (payload) => ({
  type: CONST.SMS_TEMP_ID_SUCCESS,
  payload,
});

export const smsTempId_Fail = (payload) => ({
  type: CONST.SMS_TEMP_ID_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> UPDATE USER >>>>>>>>>>>>>>>*/

export const updateSMStemp = (payload, callBack) => {
  return {
    type: CONST.UPDATE_SMS_TEMP,
    payload: { ...payload },
    callBack,
  };
};

export const updateSMStemp_Success = (payload) => ({
  type: CONST.UPDATE_SMS_TEMP_SUCCESS,
  payload,
});

export const updateSMStemp_Fail = (payload) => ({
  type: CONST.UPDATE_SMS_TEMP_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> ADD USER >>>>>>>>>>>>>>>*/

export const addSMSTemp = (payload, callBack) => {
  return {
    type: CONST.ADD_SMS_TEMP,
    payload: { ...payload },
    callBack,
  };
};

export const addSMSTemp_Success = (payload) => ({
  type: CONST.ADD_SMS_TEMP_SUCCESS,
  payload,
});

export const addSMSTemp_Fail = (payload) => ({
  type: CONST.ADD_SMS_TEMP_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> DELETE USER >>>>>>>>>>>>>>>*/

export const deleteSMSTemp = (payload, callBack) => {
  return {
    type: CONST.DELETE_SMS_TEMP,
    payload: { ...payload },
    callBack,
  };
};

export const deleteSMSTemp_Success = (payload) => ({
  type: CONST.DELETE_SMS_TEMP_SUCCESS,
  payload,
});

export const deleteSMSTemp_Fail = (payload) => ({
  type: CONST.DELETE_SMS_TEMP_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> EMAIL TEMP BY TYPE >>>>>>>>>>>>>>>*/

export const emailTempByType = (payload, callBack) => {
  return {
    type: CONST.EMAIL_TEMP_BY_TYPE,
    payload: { ...payload },
    callBack,
  };
};

export const emailTempByType_Success = (payload) => ({
  type: CONST.EMAIL_TEMP_BY_TYPE_SUCCESS,
  payload,
});

export const emailTempByType_Fail = (payload) => ({
  type: CONST.EMAIL_TEMP_BY_TYPE_FAIL,
  payload,
});

/* >>>>>>>>>>>>>> SMS TEMP BY TYPE >>>>>>>>>>>>>>>*/

export const smsTempByType = (payload, callBack) => {
  return {
    type: CONST.SMS_TEMP_BY_TYPE,
    payload: { ...payload },
    callBack,
  };
};

export const smsTempByType_Success = (payload) => ({
  type: CONST.SMS_TEMP_BY_TYPE_SUCCESS,
  payload,
});

export const smsTempByType_Fail = (payload) => ({
  type: CONST.SMS_TEMP_BY_TYPE_FAIL,
  payload,
});
